(function () {
  if (window.__FBR_WIDGET_LOADER_ACTIVE__) return;
  window.__FBR_WIDGET_LOADER_ACTIVE__ = true;

  var legacyLoaded = false;
  var productStarsLoaded = false;
  var selector = '.fbr-widget';
  var legacyWidgetScript = 'https://www.furniturebrandreviews.com/widget.js';
  var productStarsScript = 'https://app.furniturebrandreviews.com/fbr-widgets.js';
  var productStarsStylesheet = 'https://app.furniturebrandreviews.com/fbr-widgets.css';

  function loadWidget() {
    if (!document.querySelector(selector)) return;

    if (document.querySelector('[data-fbr-product-stars]')) {
      loadProductStars();
      return;
    }

    loadLegacyWidget();
  }

  function loadProductStars() {
    if (productStarsLoaded) return;
    productStarsLoaded = true;

    if (!document.querySelector('link[href="' + productStarsStylesheet + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = productStarsStylesheet;
      document.head.appendChild(link);
    }

    if (document.querySelector('script[src="' + productStarsScript + '"]')) return;

    var script = document.createElement('script');
    script.src = productStarsScript;
    script.defer = true;
    document.body.appendChild(script);
  }

  function loadLegacyWidget() {
    if (legacyLoaded) return;
    if (document.querySelector('script[src*="furniturebrandreviews.com/widget.js"]')) {
      legacyLoaded = true;
      return;
    }

    legacyLoaded = true;

    var script = document.createElement('script');
    script.src = legacyWidgetScript;
    script.async = true;
    document.body.appendChild(script);
  }

  function loadWhenIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadWidget, { timeout: 4500 });
      return;
    }
    window.setTimeout(loadWidget, 4500);
  }

  function observeWidget() {
    var target = document.querySelector(selector);
    if (!target || !('IntersectionObserver' in window)) {
      loadWhenIdle();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        loadWidget();
      }
    }, { rootMargin: '300px 0px' });

    observer.observe(target);
    loadWhenIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWidget);
  } else {
    observeWidget();
  }
})();
